const Size = {
  '4XL': '4xl',
  '3XL': '3xl',
  '2XL': '2xl',
  XL: 'xl',
  LG: 'lg',
  MD: 'md',
  SM: 'sm',
  XS: 'xs'
}
export default Size

export const listOfSizes = Object.values(Size)
